import { render, staticRenderFns } from "./MdFileIcon.vue?vue&type=template&id=5052493a"
import script from "./MdFileIcon.vue?vue&type=script&lang=js"
export * from "./MdFileIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports